import React, { useEffect } from 'react';
import { Formik } from 'formik';
import { connect } from 'react-redux';

import { getArtisanJobAction } from '../../../../modules/artisanJobs/Actions';

import {
  getPendingArtisanJobsAction,
  deleteSinglePendingArtisanProdcutAction,
  getSinglePendingArtisanJobAction,
  moderateCreateSinglePendingArtisanJobAction,
  updatePendingArtisanJobAction
} from '../../../../modules/artisanModeration/artisanJobs/Actions';
import {
  artisanJobsIsLoadingSelector,
  artisanJobByIdSelector
} from '../../../../modules/artisanJobs/Selectors';

import {
  InputField,
  CheckBox,
  TextArea,
  MultiInputField,
  SearchableSelect,
  MultiUpload,
  FormSectionTitle,
  Separator
} from '../../../../components/form';

import ModerationForm from '../../../../components/form/ModerationForm';
import { pendingArtisanJobByIdSelector } from '../../../../modules/artisanModeration/artisanJobs/Selectors';
import Checkbox from '../../../../components/form/Checkbox';
import { getArtisanCategoriesAction } from '../../../../modules/artisanCategories/Actions';
import getLangData from '../../../../utils/getLangData';
import {
  artisanCategoriesIsLoadingSelector,
  artisanCategoriesListSelector
} from '../../../../modules/artisanCategories/Selectors';
import { artisansIsLoadingSelector } from '../../../../modules/artisans/Selectors';

const profileLang = getLangData().profile_types;
const fieldsLang = getLangData().fields;
const buttonsLang = getLangData().buttons;

const ArtisanJobsForm = props => {
  const {
    jobId,
    moderationId,
    isLoading,
    updateArtisanJob,
    getArtisanJob,
    artisanJob,
    deleteArtisan,
    moderateArtisanJob,
    getJobs,
    getCategories,
    categories,
    artisansIsLoading,
    categoriesIsLoading
  } = props;

  useEffect(() => {
    // getArtisanJob(jobId);
    getJobs();
  }, [getArtisanJob, jobId]);

  return (
    <Formik
      enableReinitialize
      initialValues={{
        ...artisanJob
      }}
      onSubmit={values => {
        moderateArtisanJob(
          {
            id: jobId
          },
          values.moderationType
        );
      }}
    >
      {({ values, handleSubmit }) => (
        <ModerationForm
          handleSubmit={handleSubmit}
          isLoading={isLoading}
          heading={
            artisanJob ? `${getLangData().general_words.update} [${artisanJob.name}]` : getLangData().general_words.create_artisan_job
          }
        >
          <FormSectionTitle>{getLangData().general_words.basic_information}</FormSectionTitle>

          <SearchableSelect
            name={'artisanCID'}
            label={getLangData().general_words.artisan_categories}
            getItems={getCategories}
            options={categories}
            isLoading={categoriesIsLoading}
          />
          <InputField label={fieldsLang?.title} name='jobTitle' />
          <TextArea name='jobDescription' label={fieldsLang.descrition} />
          <InputField
            label={fieldsLang?.yearsOfExperience}
            name='yearsOfExperience'
            type='number'
          />
          <Checkbox
            name='trainingAvailable'
            label={fieldsLang.trainingAvailable}
          />
          <MultiInputField name='skillsRequired' label={fieldsLang.skills} />
        </ModerationForm>
      )}
    </Formik>
  );
};

const mapStateToProps = (state, props) => {
  const jobId = props.match.params.id;
  const moderationId = props.match.params.moderationId;
  return {
    moderationId,
    jobId,
    isLoading: artisanJobsIsLoadingSelector(state),
    // artisanJob: artisanJobByIdSelector(state, jobId),
    artisanJob: pendingArtisanJobByIdSelector(state, jobId),
    categories: artisanCategoriesListSelector(state),
    artisansIsLoading: artisansIsLoadingSelector(state),
    categoriesIsLoading: artisanCategoriesIsLoadingSelector(state)
  };
};
export default connect(mapStateToProps, {
  getArtisanJob: getSinglePendingArtisanJobAction,
  moderateArtisanJob: moderateCreateSinglePendingArtisanJobAction,
  deleteArtisanJob: deleteSinglePendingArtisanProdcutAction,
  getJobs: getPendingArtisanJobsAction,
  getCategories: getArtisanCategoriesAction
})(ArtisanJobsForm);
